import { StopType } from '../../domain/stop/Stop';
import { Text } from '../../react-components/Text';

export const StopManagementMenuTagText = ({
  mainColor,
  secondaryColor,
  textColor,
  stopType,
  children,
  height,
  width,
}: React.PropsWithChildren<{
  mainColor: string;
  textColor: string;
  secondaryColor: string;
  stopType?: StopType;
  height?: string;
  width?: string;
}>) => {
  return (
    <Text
      style={{
        background: mainColor,
        color: textColor,
        border: `2px solid ${secondaryColor}`,
        borderRadius: stopType === `pickup` ? `10px` : `50%`,
        display: `flex`,
        justifyContent: `center`,
        alignItems: `center`,
        width: width || `30px`,
        height: height || `30px`,
        maxHeight: `30px`,
        fontSize: `16px`,
      }}
    >
      {children}
    </Text>
  );
};
